exports = module.exports = require("../../node_modules/_css-loader@0.28.4@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"porder.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.4@css-loader?sourceMap!./node_modules/_vue-loader@12.2.2@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2eba2eaa","scoped":false,"hasInlineConfig":false}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=styles&index=0!./app/router/porder.vue
// module id = 259
// module chunks = 0